(ns minorodata.components.monaco.editor
  (:require [react :as react]
            [applied-science.js-interop :as js-interop]
            ["react-resize-detector" :refer [useResizeDetector]]
            ["@monaco-editor/react" :default Editor]
            ["@popsql/monaco-sql-languages" :refer [snowflakeLanguageDefinition bigqueryLanguageDefinition pgsqlLanguageDefinition]]
            [goog.functions]))


(def default-editor-options
  {:unicodeHighlight {:ambiguousCharacters true
                      :nonBasicASCII       false
                      :invisibleCharacters true}
   :semanticHighlighting.enabled true})

(defn warehouse-language [warehouse-type]
  (case warehouse-type
    "snowflake" "snowflake"
    "bigquery"  "bigquery"
    "redshift"  "pgsql"
    "sql"))


(defn editor-comp [{:keys [value language theme options overrideServices on-change editor-will-mount editor-did-mount data-cy controlled? skip-value-updates height width line]
                    :or   {value             ""
                           language          "sql" ;; Both `snowflake`, `pgsql` and `bigquery` now supported, Use `sql` for generic sql.
                           theme             "vs-dark"
                           options           {:fontSize 10}
                           overrideServices  {}
                           editor-did-mount  (fn [])
                           editor-will-mount (fn [] {})
                           controlled?       false
                           line              0}}]
  (let [editor-ref (react/useRef nil)]

    [:> Editor (merge
                {:class            "cljs-monaco-editor-container"
                 :line             line
                 :wrapperProps     {:data-cy data-cy}
                 :style            {:height height :width width}
                 :options          (merge default-editor-options options)
                 :theme            theme
                 :language         language
                 :beforeMount      (fn [monaco]
                                     ;; add custom languages
                                     (mapv (fn [language]
                                             (js-interop/call-in monaco [:languages :register] language)
                                             (js-interop/call-in monaco [:languages :onLanguage]
                                                                 (js-interop/get language :id)
                                                                 (fn []
                                                                   (-> (.loader language)
                                                                       (.then (fn [mod]
                                                                                (js-interop/call-in monaco [:languages :setMonarchTokensProvider]
                                                                                                    (js-interop/get language :id) (js-interop/get mod :language))

                                                                                (js-interop/call-in monaco [:languages :setLanguageConfiguration]
                                                                                                    (js-interop/get language :id) (js-interop/get mod :conf))))))))
                                           [snowflakeLanguageDefinition bigqueryLanguageDefinition pgsqlLanguageDefinition])

                                     (when editor-will-mount
                                       (editor-will-mount monaco)))
                 :onMount          (fn on-mount [editor monaco]
                                     (js-interop/assoc! editor-ref :current editor)

                                     (when editor-did-mount
                                       (editor-did-mount editor monaco)))
                 :onChange         on-change
                 :overrideServices overrideServices}
                (if controlled?
                  {:value value}
                  {:defaultValue value}))]))


(defn editor [params]
  (let [{:keys [ref height width]} (js->clj (useResizeDetector #js {:handleWidth  true
                                                                    :handleHeight true
                                                                    :refreshMode  "throttle"
                                                                    :refreshRate  100})
                                            :keywordize-keys true)]
    [:div {:style {:height "100%" :width "100%"}
           :ref ref}
     [:f> editor-comp (assoc params
                             :height height
                             :width  width)]]))
